import { __exportAll } from "../../../_virtual/_rolldown/runtime.js";
import { createElementBlock, createElementVNode, openBlock } from "vue";
//#region src/components/ScalarIcon/icons/Magic.svg?component
var Magic_exports = /* @__PURE__ */ __exportAll({
	default: () => Magic_default,
	render: () => render$1
});
var _hoisted_1 = {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 24 24"
};
function render$1(_ctx, _cache) {
	return openBlock(), createElementBlock("svg", _hoisted_1, [..._cache[0] || (_cache[0] = [createElementVNode("path", {
		fill: "none",
		stroke: "currentColor",
		"stroke-linecap": "round",
		"stroke-linejoin": "round",
		d: "m.75 23.25 15-15m-5.25 0H8.25m15 0H21M21 3l-1.591 1.591M15.75 3V.75m0 15V13.5m-3.659-8.909L10.5 3M21 13.5l-1.591-1.591"
	}, null, -1)])]);
}
var Magic_default = { render: render$1 };
//#endregion
export { Magic_exports, Magic_default as default, render$1 as render };

//# sourceMappingURL=Magic.svg_component.js.map